<script>
  import { onMount, createEventDispatcher } from "svelte";
  let dispatch = createEventDispatcher();
  import { Username, SecurityQuestions } from "./store.js";

  onMount(async function() {
    if ($Username.value == '')
      dispatch("pageChange", "/account/login");
  });
</script>

<form action="" class="box">
  <h1 class="title is-4">Password Changed Successfully </h1>
  <p>
    Password for <strong>{$Username.value}</strong> has been successfully updated.
  </p>
  <div style="text-align: right; margin-top: 15px;">
    <a href="/signin/{$Username.value}/" class="button is-purple">Login to eAdmissions</a>
  </div>

  {#if $SecurityQuestions.length > 1}
    <p style="margin-top: 30px;">
      If you wish to reconfigrue your security questions you may do so by clicking on the button below.
    </p>

    <div style="text-align: right; margin-top: 15px;">
      <a href='/register/securityquestion/{$Username.value}/' class="button is-primary">Reconfigure Security Questions</a>
    </div>
  {:else}
    <p style="margin-top: 30px;">
      To help confirm your identity, if you forget your password and it needs to
      be reset, please configure your security questions.
    </p>

    <div style="text-align: right; margin-top: 15px;">
      <a href="/register/securityquestion/{$Username.value}/" class="button is-primary">Setup Security Questions</a>
    </div>
  {/if}
</form>